module.exports = __webpack_public_path__ + "static/media/change.5da4807b.png";